import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/external-link.css.js";
import withStyles from "components/with-styles";
import cn from "classnames";
import { useImperativeTracking } from "components/tracking";

const getUrlFormatted = href =>
  href && (href.startsWith("http://") || href.startsWith("https://") ? href : "http://" + href);

const ExternalLink = ({ classes, children, onClick, disabled, className, href, ...props }) => {
  const track = useImperativeTracking();

  if (disabled) {
    return children;
  }

  const url =
    href && !href.includes("://") && !href.startsWith("/") ? getUrlFormatted(href).replace("///", "//") : href;

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={url}
      onClick={() => track(`User clicked external link [${url}]`)}
      className={cn(className, classes.externalLink)}
      {...props}
    >
      {children}
    </a>
  );
};

ExternalLink.propTypes = {
  /*
   * Función que se llama al hacer click
   */
  onClick: PropTypes.func,
  /*
   * Target del link
   */
  target: PropTypes.string,
  /*
   * Url a la que enlaza el link
   */
  href: PropTypes.string,
  /*
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /*
   * Evita que se genere el enlace
   */
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ExternalLink);
